import { render, staticRenderFns } from "./UserGroupUsersTableActions.vue?vue&type=template&id=fd98cbd0"
import script from "./UserGroupUsersTableActions.vue?vue&type=script&lang=js"
export * from "./UserGroupUsersTableActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports